/* eslint-disable object-curly-newline,no-unused-expressions,no-unused-vars */
import { settings } from 'app/_shared/session'
import { back, forceRedirect, persistChange, persistCheck, redirect } from '@app/_shared/events'
import { update } from 'app/_shared/events/util'
import actionByKey from 'app/_shared/events/action/byKey'
import chain from 'app/_shared/events/util/chain'
import contextList from 'app/guest/event/list/context'
import setContext from 'app/guest/event/setContext'
import closeDialog from 'app/guest/event/closeDialog'
import getSupport from 'app/guest/event/getSupport'
import redirectWithUsername from 'app/guest/event/redirectWithUsername'
import resetForm from 'app/guest/event/resetForm'
import needHelp from 'app/guest/event/needHelp'
import confirmOnboarding from 'app/guest/event/confirmOnboarding'
import focusPasswordField from 'app/guest/event/focusPasswordField'
import { curry } from 'lib/util'
import routeComposition from 'trait/composition/route'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'

export default {
  onOpen: {
    contextList,
  },
  onClick: {
    setContext,
    validateLogin: actionByKey('validateLogin'),
    validateRedirect: actionByKey('validateRedirect'),
    closeDialog,
    getSupport,
    redirect,
    forceRedirect,
    redirectWithUsername,
    needHelp,
    confirmOnboardingAndAction: chain(
      confirmOnboarding,
      actionByKey('onboardingSuccess'),
    ),
  },
  onCreate: {
    redirectToRegistration: curry(async (module, component, event) => {
      try {
        const moduleState = module[G.STATE]
        const { route } = module[G.STATE][G.ACTION][G.UI]?.create || {}
        moduleState[G.ROUTE] = routeComposition(route.module, route.action)
        await redirectSequence(module)({ detail: event?.detail })
      } catch (e) {
        console.error(e)
      }
    }),
  },
  onClose: {
    closeDialog,
    redirect,
    back,
  },
  onChange: {
    persistChange,
    persistUsername: chain(
      persistChange,
      resetForm,
    ),
    persistCheck,
  },
  onSubmit: {
    validateRedirect: chain(
      actionByKey('validateRedirect'),
      focusPasswordField,
    ),
    validateLogin: actionByKey('validateLogin'),
    focusPasswordField,
  },
  onBlur: {
    validateUsername: chain(
      (module, component, event) => {
        if (!settings.singleStepLogin) {
          throw Error('No single step login')
        }
      },
      actionByKey('validateRedirect'),
      // If we don't update the UI, the AppBar won't display
      // the actual state of the history stack after it has
      // been altered by the redirect hook
      update,
    ),
  },
}
